import { translationsEnUS } from "./translations/en-US";
import { translationsFrFR } from "./translations/fr-FR";
import {
  AvailableLanguageOnApp,
  LangCompleteData,
  LangObject,
  LocalesDict,
} from "./types/i18n.types";

export const langInAppDictionnary: LangCompleteData = {
  [LocalesDict.ENGLISH_US]: {
    translatedText: translationsEnUS,
    pictureName: LocalesDict.ENGLISH_US,
    langID: 0,
    locale: LocalesDict.ENGLISH_US,
  },
  [LocalesDict.FRENCH]: {
    translatedText: translationsFrFR,
    pictureName: LocalesDict.FRENCH,
    langID: 1,
    locale: LocalesDict.FRENCH,
  },
};

export const availableLangues = Object.keys(
  langInAppDictionnary
) as AvailableLanguageOnApp[];

export const arrayLangsInApp = availableLangues.reduce(
  (acc: LangObject[], current: AvailableLanguageOnApp) => {
    const langToAdd = langInAppDictionnary[current];
    return [...acc, langToAdd];
  },
  []
);

export const expandLocaleDictionnary = {
  fr: LocalesDict.FRENCH,
  en: LocalesDict.ENGLISH_US,
};
export const localeToLangDictionnary = {
  [LocalesDict.FRENCH]: "fr",
  [LocalesDict.ENGLISH_US]: "en",
};

export const LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE = "languageSettings";
